module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facing-type-card-user-select"
  }, [_c('div', {
    staticClass: "facing-type-card-user-select__back"
  }, [_c('button', {
    staticClass: "facing-type-card-user-select__back--button",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('img', {
    staticClass: "back-button__image",
    attrs: {
      "src": require("../images/arrow_left_brown.png"),
      "alt": "戻る"
    }
  }), _c('span', {
    staticClass: "back-button__text"
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "facing-type-card-user-select__select-shop"
  }, [_c('div', {
    staticClass: "facing-type-card-user-select__select-shop--title"
  }, [(_vm.target === 'give') ? [_vm._v("誰に渡すニャン？")] : [_vm._v("誰からもらったニャン？")]], 2), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedShopId),
      expression: "selectedShopId"
    }],
    staticClass: "facing-type-card-user-select__select-shop--input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedShopId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.searchUsersByShopId]
    }
  }, [_vm._l((_vm.shops), function(shop) {
    return [_c('option', {
      key: shop.id,
      domProps: {
        "value": shop.id
      }
    }, [_vm._v(_vm._s(shop.shop_name))])]
  })], 2)]), _c('ul', {
    staticClass: "facing-type-card-user-select__users"
  }, [_vm._l((_vm.users), function(user, userIndex) {
    return [_c('li', {
      key: user.id
    }, [_c('button', {
      staticClass: "facing-type-card-user-select__users--list",
      on: {
        "click": function($event) {
          _vm.selectUser(userIndex)
        }
      }
    }, [_c('div', {
      staticClass: "user-list__item"
    }, [_c('div', {
      staticClass: "user-list__item--image-wrapper"
    }, [_c('img', {
      staticClass: "user-list__item--image",
      attrs: {
        "src": _vm.getUserImage(user.attributes['profile-path']),
        "alt": user.attributes.name
      }
    })]), _c('div', {
      staticClass: "user-list__item--name-wrapper"
    }, [_c('div', [_c('div', {
      staticClass: "user-list__item--shop-name"
    }, [_vm._v(_vm._s(user.attributes['shop-name']) + " " + _vm._s(user.attributes['user-type-name']))]), _c('div', {
      staticClass: "user-list__item--name"
    }, [_vm._v(_vm._s(user.attributes['user-name']) + " " + _vm._s(user.attributes['user-firstname']))])])])])])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78d828c8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/facingtype-card-user-select.pug
// module id = 1420
// module chunks = 1